var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload__story"},[_c('div',{staticClass:"upload__story__button",on:{"click":_vm.selectImage}},[_vm._v(" Subir story ")]),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"file",attrs:{"type":"file","name":"photo"},on:{"change":_vm.onFileChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }